module.exports = __webpack_public_path__ + "static/media/tape.e25d94cc.svg";